<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {lookup2,disabledBeforeTodayDates,isNumber} from '@/apis/common'
import {saveOrder} from '@/apis/order'
import LanguageSwitch from '../../components/language-switch';
import {
  required,numeric
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "SLCP Verification Application Form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,DatePicker,LanguageSwitch,Multiselect},
  validations: {
    form: {
      clientName: { 
            required,
      },
      taxCode: { 
            check(value){
                if (localStorage.getItem('language')!="zh-CN"&&value!=null && value.trim().length === 0) {
                  return false;
                }else{
                  return true;
                }                
            },
      },
      country: { 
        required,
      },
      address: { 
            required,
      },
      contact: { 
            required,
      },
      title: { 
            required,
      },
      mobile: { 
            required,
      },
      email: { 
            required,
      },
      companyInfo:{
          employee:{
            required,
            numeric
          },
          manager:{
            required,
            numeric
          }          
      },
      orderDetail:{
        auditDateFrom:{
          required
        },
        auditDateTo:{
          required
        }
      }
    },
  },
  props:{
    sales:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      title: "SLCP验证申请",
      orderNo:null,
      clientNo:null,
      disabledDates: disabledBeforeTodayDates,
      showTaxCode:false,
      showLegalPerson:false,
      form:{
        orderId:null,
        orderType:"SLCP",
        orderSource:"WP",
        orderStatus:'N',
        paymentStatus:'Y',
        orderDetail:{
          type:"Step 1",
          model:"Onsite",
          experience:"1",
          experienceNum:"",
          selfassessment:"y",
          postDate:"",
          ahSystem:"higg",
          higgID:"",
          ffcID:"",
          otherID:"",
          announcementType:"1",
          days:"",
          auditDateFrom:"",
          auditDateTo:"",
        },
        clientId:null,
        clientName:"",
        clientNameEn:"",
        taxCode:"",
        country:"",
        province:"",
        city:"",
        station:"",
        address:"",
        addressEn:"",
        promoteBrand:"",
        companyInfo:{
          productType:"",
          technology:"",
          employee:"",
          manager:"",
          productionBuildings:"",
          dormitories:"",
          warehouses:"",
          otherBuildings:"",
          csr:"",
          serviceProvider:"",
          legalPersonName:"",
          legalPersonTitle:""          
        },
        contact:"",
        email:"",
        mobile:"",
        title:"",
        department:"",
        salesTag:"",
      },
      submitted:false,
      success:false,
      lookupRawData:{},
      lookupData:{
        cnty:{},
      },
      lookupDataSelected:{
        cnty:[]
      },
    };
  },
  created(){
    if(this.$route.query.tag!=undefined){
      this.form.salesTag = this.$route.query.tag;
    }
    this.init();
  },
  computed:{
    showTipWorker(){
      if(isNumber(this.form.companyInfo.employee)){
        let workList = [100,200,500,1000]
        for(let i=0;i<workList.length;i++){
          if(this.form.companyInfo.employee>=workList[i]*0.95 &&this.form.companyInfo.employee<=workList[i]){
            return true
          }
        }
      }
      return false
    },
    showTipManager(){
      if(isNumber(this.form.companyInfo.employee)&&isNumber(this.form.companyInfo.manager)){
        if(this.form.companyInfo.manager/this.form.companyInfo.employee>=0.3 ||this.form.companyInfo.manager/this.form.companyInfo.employee<0.1){
          return true
        }
      }
      return false
    },
  },
  watch:{
    "lookupDataSelected.cnty"(){
      if(this.lookupDataSelected.cnty.value!=undefined){
        this.form.country = this.lookupDataSelected.cnty.value
      }
    },
    "form.country"(){
      if(this.form.country=='VN'){
        this.showLegalPerson = true
      }else{
        this.showLegalPerson = false
      }
    },    
    "form.address"(){
      if(this.form.address.indexOf("省")!=-1||this.form.address.indexOf("市")!=-1){
        let address = this.form.address.replace("，",",").split("市")[0].replace("中国","").trim()
        if(address.indexOf("省")!=-1){
          let province_city = address.split("省")
          this.form.city = ""||province_city[1].trim()
        }else{
          this.form.city = address
        }
      }
    },    
  },
  methods: {
    async init(){
      // 初始化数据字典
      this.lookupRawData = await lookup2("CNTY");
      this.lookupData.cnty = this.lookupRawData["CNTY"].map(item=>{return {...item,labelCn:item.label}});
      this.changeLookupLanguage()
    },
    changeLookupLanguage(){
      if(localStorage.getItem('language')=="zh-CN"){
        this.showTaxCode = false;
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelCn}});
      }else{
        this.showTaxCode = true;
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelEn}});
      }
    },
    handleSaveClient() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.success = false
            return;
        } else {
          let params = {...this.form}
          params.companyInfo = JSON.stringify(this.form.companyInfo)
          params.orderDetail = JSON.stringify(this.form.orderDetail)
          params.sales = this.sales
          params.language = localStorage.getItem('language')
          params.serviceYear = this.form.orderDetail.auditDateFrom.substring(0,4)
          if(this.lookupDataSelected.cnty.value!=undefined){
            params.country = this.lookupDataSelected.cnty.value
          }
          this.success = true
          saveOrder('SLCP',params).then(()=>{
            Swal.fire(this.$t("common.successMsg"),"", "success");
          }).catch(()=>{
            this.success = false
          })
        }
    },
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
    }

  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{ $t("slcp.formName") }}</h5>
                          </div>
                        </div>
                        <language-switch @change="changeLookupLanguage"></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                01
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{ $t("common.verfRequirement") }}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.type") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="type1"
                                        name="type"
                                        class="form-check-input"
                                        value="Step 1"
                                        v-model="form.orderDetail.type"
                                      />
                                      <label class="form-check-label" for="type1"
                                        >Step 1</label
                                      >
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="type2"
                                        name="type"
                                        class="form-check-input"
                                        value="Step 1+2"
                                        v-model="form.orderDetail.type"
                                      />
                                      <label class="form-check-label" for="type2">Step 1 + 2</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="type3"
                                        name="type"
                                        class="form-check-input"
                                        value="Step 1+2+3"
                                        v-model="form.orderDetail.type"
                                      />
                                      <label class="form-check-label" for="type3">Step 1 + 2 + 3</label>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.experience") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience1"
                                        name="experience"
                                        class="form-check-input"
                                        value="1"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience1">{{ $t("slcp.experience1") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience2"
                                        name="experience"
                                        class="form-check-input"
                                        value="2"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience2">{{ $t("slcp.experience2") }}</label>
                                      <span v-if="form.orderDetail.experience==2">&nbsp;&nbsp;<input type="text" style="width:30px" id="experienceNum" v-model="form.orderDetail.experienceNum"> {{ $t("slcp.times") }}</span>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="experience3"
                                        name="experience"
                                        class="form-check-input"
                                        value="3"
                                        v-model="form.orderDetail.experience"
                                      />
                                      <label class="form-check-label" for="experience3">{{ $t("slcp.experience3") }}</label>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.selfassessment") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="selfassessment1"
                                        name="selfassessment"
                                        class="form-check-input"
                                        value="y"
                                        v-model="form.orderDetail.selfassessment"
                                      />
                                      <label class="form-check-label" for="selfassessment1">{{ $t("common.yes") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="selfassessment2"
                                        name="selfassessment"
                                        class="form-check-input"
                                        value="n"
                                        v-model="form.orderDetail.selfassessment"
                                      />
                                      <label class="form-check-label" for="selfassessment2">{{ $t("common.no") }}</label>
                                    </div>
                                  </div>
                                  <div class="mb-3" v-if="form.orderDetail.selfassessment=='y'">
                                    <label class="form-label">{{ $t("slcp.postDate") }} :</label>
                                    <date-picker
                                      v-model="form.orderDetail.postDate"
                                      format="YYYY-MM-DD"
                                      value-type="format"
                                      :first-day-of-week="1"
                                      lang="en"
                                      placeholder="select date"
                                    ></date-picker>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.ahSystem") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="ahSystem1"
                                        name="ahSystem"
                                        class="form-check-input"
                                        value="higg"
                                        v-model="form.orderDetail.ahSystem"
                                      />
                                      <label class="form-check-label" for="ahSystem1">Worldly (Higg) ID &nbsp;&nbsp;</label>
                                      <input type="text" class="form-control form-control-sm" style="width:100px;display: inline;" placeholder="Higg ID" id="higgid" v-model="form.orderDetail.higgID">
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="ahSystem3"
                                        name="ahSystem"
                                        class="form-check-input"
                                        value="other"
                                        v-model="form.orderDetail.ahSystem"
                                      />
                                      <label class="form-check-label" for="ahSystem3">{{ $t("slcp.other") }} &nbsp;&nbsp;</label>
                                      <input type="text" class="form-control form-control-sm" style="width:100px;display: inline;" placeholder="ID" id="otherid" v-model="form.orderDetail.otherID">
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label" for="promoteBrand">{{ $t("slcp.promoteBrand") }} :</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      id="promoteBrand"
                                      v-model="form.promoteBrand"
                                    />
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.announcementType") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="announcementType1"
                                        name="announcementType"
                                        class="form-check-input"
                                        value="1"
                                        v-model="form.orderDetail.announcementType"
                                      />
                                      <label class="form-check-label" for="announcementType1">{{ $t("slcp.announcementType1") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="announcementType2"
                                        name="announcementType"
                                        class="form-check-input"
                                        value="2"
                                        v-model="form.orderDetail.announcementType"
                                      />
                                      <label class="form-check-label" for="announcementType2">{{ $t("slcp.announcementType2") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="announcementType3"
                                        name="announcementType"
                                        class="form-check-input"
                                        value="3"
                                        v-model="form.orderDetail.announcementType"
                                      />
                                      <label class="form-check-label" for="announcementType3">{{ $t("slcp.announcementType3") }} &nbsp;&nbsp;</label>
                                      <input type="text" class="form-control form-control-sm" style="width:100px;display: inline;" placeholder="days" id="days" v-model="form.orderDetail.days">
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label">{{ $t("slcp.auditDate") }} :</label>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <date-picker
                                          v-model="form.orderDetail.auditDateFrom"
                                          format="YYYY-MM-DD"
                                          value-type="format"
                                          :disabled-date="disabledDates"
                                          :first-day-of-week="1"
                                          lang="en"
                                          placeholder="from"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.auditDateFrom.$error,
                                          }"
                                        ></date-picker>
                                        <div
                                            v-if="submitted && $v.form.orderDetail.auditDateFrom.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.auditDateFrom.required">
                                                  {{ $t("slcp.auditDateError") }}.
                                                </span>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <date-picker
                                          v-model="form.orderDetail.auditDateTo"
                                          format="YYYY-MM-DD"
                                          value-type="format"
                                          :disabled-date="disabledDates"
                                          :first-day-of-week="1"
                                          lang="en"
                                          placeholder="to"
                                          :class="{
                                              'is-invalid': submitted && $v.form.orderDetail.auditDateTo.$error,
                                          }"
                                        ></date-picker>
                                        <div
                                            v-if="submitted && $v.form.orderDetail.auditDateTo.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.auditDateTo.required">
                                                  {{ $t("slcp.auditDateError") }}.
                                                </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="mb-3">
                                    <label class="form-label mb-3 d-flex">{{ $t("slcp.model") }}:</label>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="model1"
                                        name="model"
                                        class="form-check-input"
                                        value="Onsite"
                                        v-model="form.orderDetail.model"
                                      />
                                      <label class="form-check-label" for="model1">{{ $t("slcp.model1") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="model3"
                                        name="model"
                                        class="form-check-input"
                                        value="All"
                                        v-model="form.orderDetail.model"
                                      />
                                      <label class="form-check-label" for="model3">{{ $t("slcp.model3") }}</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                      <input
                                        type="radio"
                                        id="model2"
                                        name="model"
                                        class="form-check-input"
                                        value="Offsite"
                                        v-model="form.orderDetail.model"
                                      />
                                      <label class="form-check-label" for="model2">{{ $t("slcp.model2") }}</label>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                02
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.baseInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-name-input">{{$t("common.clientNameLocal")}}</label>
                                              <input type="text" class="form-control" id="gen-info-name-input" v-model="form.clientName"
                                              :class="{
                                                      'is-invalid': submitted && $v.form.clientName.$error,
                                                  }">
                                              <div
                                                  v-if="submitted && $v.form.clientName.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.clientName.required">
                                                        {{$t("common.clientNameLocalError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                      <div class="col-lg-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="gen-info-name-en-input">{{$t("common.clientNameEn")}}</label>
                                              <input type="text" class="form-control" id="gen-info-name-en-input"  v-model="form.clientNameEn">
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row" v-show="showTaxCode">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-taxcode-input">{{$t("common.taxCode")}}</label>
                                              <input type="text" class="form-control" id="gen-info-taxcode-input" v-model="form.taxCode"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.taxCode.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.taxCode.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.taxCode.check">
                                                        {{$t("common.taxCodeError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                  </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-country-input">{{$t("common.country")}}</label>
                                                <multiselect 
                                                id="gen-info-country-input"
                                                v-model="lookupDataSelected.cnty" 
                                                :options="lookupData.cnty"
                                                label="label"
                                                track-by="value"
                                                :class="{
                                                        'is-invalid': submitted && $v.form.country.$error,
                                                    }"
                                                ></multiselect>
                                                <div
                                                    v-if="submitted && $v.form.country.$error"
                                                    class="invalid-feedback"
                                                    >
                                                        <span v-if="!$v.form.country.required">
                                                          {{$t("common.countryError")}}.
                                                        </span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-province-input">{{$t("common.province")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-province-input" v-model="form.province">
                                            </div>                                            
                                        </div>    
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-address-input">{{$t("common.addressLocal")}}</label>
                                              <input type="text" class="form-control" id="gen-info-address-input" v-model="form.address"
                                              :class="{
                                                      'is-invalid': submitted && $v.form.address.$error,
                                                  }">
                                              <div
                                                  v-if="submitted && $v.form.address.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.address.required">
                                                        {{$t("common.addressLocalError")}}.
                                                      </span>
                                              </div>                                        
                                      </div>
                                      <div class="col-lg-6">
                                          <div class="mb-3">
                                              <label class="form-label" for="gen-info-address-en-input">{{$t("common.addressEn")}}</label>
                                              <input type="text" class="form-control" id="gen-info-address-en-input" v-model="form.addressEn">
                                          </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-lg-12 mb-3">
                                              <label class="form-label" for="gen-info-station-input">{{$t("common.station")}}</label>
                                              <input type="text" class="form-control" id="gen-info-station-input" v-model="form.station">
                                      </div>                                            
                                  </div>    
                                  <div class="row" v-if="showLegalPerson">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-legalPersonName-input">{{$t("common.legalPersonName")}}</label>
                                              <input type="text" class="form-control" id="gen-info-legalPersonName-input" v-model="form.companyInfo.legalPersonName">
                                      </div>
                                      <div class="col-lg-6 mb">
                                              <label class="form-label" for="gen-info-legalPersonTitle-en-input">{{$t("common.legalPersonTitle")}}</label>
                                              <input type="text" class="form-control" id="gen-info-legalPersonTitle-en-input" v-model="form.companyInfo.legalPersonTitle">
                                      </div>
                                  </div>                                                                  
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="employee">{{$t("slcp.employee")}} </label>
                                              <input type="text" class="form-control" id="employee" v-model="form.companyInfo.employee"
                                              :class="{
                                                      'is-invalid': submitted && $v.form.companyInfo.employee.$error,
                                                  }">
                                              <div
                                                  v-if="submitted && $v.form.companyInfo.employee.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.companyInfo.employee.required">
                                                        {{$t("slcp.employeeError")}}
                                                      </span>
                                                      <span v-if="!$v.form.companyInfo.employee.numeric">
                                                        {{$t("common.numericError")}}
                                                      </span>
                                              </div>
                                              <div v-if="showTipWorker" class="red">
                                                    {{$t("slcp.tipWorker")}}
                                              </div>
                                              <label class="form-label  mt-3" for="managers">{{$t("slcp.manager")}}</label>
                                              <input type="text" class="form-control" id="managers"  v-model="form.companyInfo.manager"
                                              :class="{
                                                      'is-invalid': submitted && $v.form.companyInfo.manager.$error,
                                                  }">
                                              <div
                                                  v-if="submitted && $v.form.companyInfo.manager.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.companyInfo.manager.required">
                                                        {{$t("slcp.managerError")}}
                                                      </span>
                                                      <span v-if="!$v.form.companyInfo.manager.numeric">
                                                        {{$t("common.numericError")}}
                                                      </span>
                                              </div>
                                              <div v-if="showTipManager" class="red">
                                                {{$t("slcp.tipManager")}}
                                              </div>

                                      </div>
                                      <div class="col-lg-6 mb-3">
                                        <div style="font-weight: bold;">{{$t("slcp.workerInclude")}}</div>{{$t("slcp.workerDetail")}}
                                        <div style="font-weight: bold;">{{$t("slcp.workerExclude")}}</div>{{$t("slcp.workerExDetail")}}
                                      </div>     
                                  </div>                                                            
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="productionBuildings">{{$t("slcp.productionBuildings")}}</label>
                                              <input type="text" class="form-control" id="productionBuildings" v-model="form.companyInfo.productionBuildings">
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="dormitories">{{$t("slcp.dormitories")}}</label>
                                              <input type="text" class="form-control" id="dormitories"  v-model="form.companyInfo.dormitories">
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="warehouses">{{$t("slcp.warehouses")}}</label>
                                              <input type="text" class="form-control" id="warehouses" v-model="form.companyInfo.warehouses">
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="otherBuildings">{{$t("slcp.otherBuildings")}}</label>
                                              <input type="text" class="form-control" id="otherBuildings"  v-model="form.companyInfo.otherBuildings">
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="productType">{{$t("slcp.productType")}}</label>
                                              <input type="text" class="form-control" id="productType"   v-model="form.companyInfo.productType">
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="technology">{{$t("slcp.technology")}}</label>
                                              <input type="text" class="form-control" id="technology"  v-model="form.companyInfo.technology">
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="csr">{{$t("slcp.csr")}}</label>
                                              <input type="text" class="form-control" id="csr" v-model="form.companyInfo.csr">
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="serviceProvider">{{$t("slcp.serviceProvider")}}</label>
                                              <input type="text" class="form-control" id="serviceProvider" v-model="form.companyInfo.serviceProvider">
                                      </div>
                                      
                                  </div>
                              </div>
                            </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.contactInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-contact-input">{{$t("common.contact")}}</label>
                                              <input type="text" class="form-control" id="gen-info-contact-input" v-model="form.contact"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.contact.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.contact.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.contact.required">
                                                        {{$t("common.contactError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                      <div class="col-lg-6 mb-3">
                                        <label class="form-label" for="gen-info-title-input">{{$t("common.title")}}</label>
                                              <input type="text" class="form-control" id="gen-info-title-input" v-model="form.title"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.title.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.title.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.title.required">
                                                        {{$t("common.titleError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                  </div>
                                  <div class="row">
                                      <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-mobile-input">{{$t("common.mobile")}}</label>
                                              <input type="text" class="form-control" id="gen-info-mobile-input" v-model="form.mobile"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.mobile.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.mobile.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.mobile.required">
                                                        {{$t("common.mobileError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                      <div class="col-lg-6 mb-3" >
                                              <label class="form-label" for="gen-info-email-input">{{$t("common.email")}}</label>
                                              <input type="text" class="form-control" id="gen-info-email-input" v-model="form.email"
                                              :class="{
                                                  'is-invalid': submitted && $v.form.email.$error,
                                              }">
                                              <div
                                                  v-if="submitted && $v.form.email.$error"
                                                  class="invalid-feedback"
                                                  >
                                                      <span v-if="!$v.form.email.required">
                                                        {{$t("common.emailError")}}.
                                                      </span>
                                              </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </form>
                          <div>
                              <button type="button" class="btn btn-primary w-sm"  @click="handleSaveClient" :disabled="success">{{$t("common.submit")}}</button> {{$t("common.hotline")}}: +86 755 21608956/ +84 932 130 677
                              <button type="button" class="btn btn-btn-secondary w-sm" @click="handleGoHome" v-if="false">{{$t("common.moreService")}}</button>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
  .is-invalid .multiselect__tags{
    border:1px solid #ec4561 !important;
  }
</style>
